module.exports = __webpack_public_path__ + "images/emoji/mask.03b308741dd7de82a7fe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mask.png
// module id = xfz0
// module chunks = 2